import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const SportIconColored: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="22" height="21" viewBox="0 0 22 21">
		<g transform="translate(-40 -11)">
			<path d="M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z" transform="translate(40 18)" fill="#48934b" />
			<g transform="translate(-4.023 -13)">
				<circle cx="9" cy="9" r="9" transform="translate(48.023 24)" fill="#9eff57" />
				<path
					d="M-1205.639-3920.853a9.248,9.248,0,0,0-4.876-7.161,9.433,9.433,0,0,0-8.558-.45,12.277,12.277,0,0,0-1.878,1,8.931,8.931,0,0,1,.6-2.061q.309-.152.643-.294a11.02,11.02,0,0,1,9.915.495,10.756,10.756,0,0,1,5.558,7.764,9.026,9.026,0,0,1-1.3,1.753C-1205.554-3920.147-1205.587-3920.5-1205.639-3920.853Z"
					transform="translate(1269.092 3959)"
					fill="#48934b"
				/>
				<path
					d="M-1212.466-3924.126a10.646,10.646,0,0,1,5.905-5.067,8.952,8.952,0,0,1,.412,1.441,9.076,9.076,0,0,0-5,4.347,9.461,9.461,0,0,0-1.171,6.007,8.934,8.934,0,0,1-1.461.32A10.955,10.955,0,0,1-1212.466-3924.126Z"
					transform="translate(1272 3959)"
					fill="#48934b"
				/>
				<path
					d="M-1215.92-3917.08a9.11,9.11,0,0,0,4.63-3.918,8.733,8.733,0,0,0,1.166-6.462,8.951,8.951,0,0,1,1.448-.38,10.3,10.3,0,0,1-1.333,7.623,10.666,10.666,0,0,1-5.476,4.569A8.942,8.942,0,0,1-1215.92-3917.08Z"
					transform="translate(1264.143 3951.973)"
					fill="#48934b"
				/>
			</g>
		</g>
	</svg>
);
